/* BJ → PENÍZE JEN TAM, KDE SEDÍ MĚNA (nález CRM-SK-04/05/08, 18. 10. 2026).
 *
 * Koeficienty kariérních pozic (data/crmData.js CAREER_POSITIONS, např. R1 = 87,5)
 * jsou v KORUNÁCH za BJ. Slovenská sazba (€/BJ) v repu NENÍ a nikdo ji neověřil
 * (CRM-SK-01, rozhodnutí majitele). Kdyby se BJ × 87,5 jen přeznačilo na „€",
 * slovenský poradce by viděl ~25× víc peněz, než dostane. Proto:
 *   tenant v CZK → BJ × koeficient (dnešní stav),
 *   jiná měna    → null = volající ukáže „—" nebo jen BJ. Žádný kurz, žádný odhad.
 */
export const MENA_KOEFICIENTU = "CZK";

/** Lze u téhle měny tenanta přepočítat BJ na peníze? */
export function umiBjNaPenize(kodMeny) {
  return String(kodMeny || "").toUpperCase() === MENA_KOEFICIENTU;
}

/** BJ × koeficient v měně tenanta, nebo null (jiná měna / nečíslo). */
export function bjNaPenize(bj, koef, kodMeny) {
  if (!umiBjNaPenize(kodMeny)) return null;
  const n = Number(bj) * Number(koef);
  return Number.isFinite(n) ? n : null;
}

/* SK TENANT: PROVIZE A HODNOTA KLIENTA SKRYTÉ (rozhodnutí majitele 19. 10. 2026,
 * bod 3 SOUHRN-SK: „slovensky, eura, vše ať sedí“). Dokud nedorazí slovenské
 * koeficienty pozic v €/BJ, místo částky se ukáže tahle hláška — nikdy kurz,
 * nikdy korunový koeficient přeznačený na €. Jazyk hlášky = jazyk UI. */
export function hlaskaBezKoeficientu(lang) {
  return lang === "sk" ? "Slovenský kariérny plán zatiaľ chýba" : "Slovenský kariérní plán zatím chybí";
}
